import type { LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { FormRadio, ProgressButton } from "@shared/ui";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { REQUEST_CONSULTANT_CALL_OPTIONS } from "../constants";

export interface StepFields {
	requestConsultantCall: boolean;
	lastName: string;
	firstName: string;
	email: string;
	phone: string;
	cityName: string;
	cityId?: number;
}

export class LeadForm extends BasicLeadForm {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>A részletes eredményedet e-mailben fogjuk elküldeni számodra!</>,
	};

	protected initValues(): StepFields {
		return {
			lastName: undefined,
			firstName: undefined,
			cityName: undefined,
			phone: undefined,
			email: undefined,
			cityId: undefined,
			requestConsultantCall: undefined,
		};
	}

	protected renderContent(
		_values: LeadFormStepFields,
		_form: FormApi<LeadFormStepFields, Partial<LeadFormStepFields>>,
	): ReactNode {
		return (
			<>
				{super.renderHeader()}
				<Card.Body className="bg-white">
					{super.renderFields()}

					<FormRadio
						label=""
						name="requestConsultantCall"
						options={REQUEST_CONSULTANT_CALL_OPTIONS}
						variant="button"
						required
						boldFirstOption
						className="text-dark border rounded pt-2"
					/>
					{super.renderPrivacyStatement()}
				</Card.Body>
				<Card.Footer className="text-center bg-white">
					<ProgressButton
						type="submit"
						variant="primary"
						className="font-weight-bold"
						block
						disabled={super.isDisabled()}
					>
						Elküldöm
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
